import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LuHouse, LuBell, LuHeart, LuPlus, LuMessagesSquare, LuUserRound, LuMenu, LuX } from "react-icons/lu";
import HeaderLogo from "./HeaderLogo";
import LanguageSelector from "./LanguageSelector";
import UserMenu from "./UserMenu";
import HeaderMobileMenu from "./HeaderMobileMenu";

// Presentation only: account, creation and navigation keep their existing handlers.
export default function PhoneHeader({ menuOpen, accountOpen, setAccountOpen, setMenuOpen, toggleMenu,
  toggleRef, menuRef, addAdMenuOpen, setAddAdMenuOpen, handleMenuItemClick, handleCreateAdClick, newIncomingMessage }) {
  const { t } = useTranslation();
  const [panelMode, setPanelMode] = useState("menu");
  const openMenu = () => { setPanelMode("menu"); if (menuOpen && panelMode === "publish") setAddAdMenuOpen(false); else toggleMenu(); };
  const { pathname } = useLocation();
  const route = pathname.toLowerCase();
  const context = route.startsWith("/category/sale") ? "sale" : route.startsWith("/category/rent") ? "rent"
    : route === "/vacation" ? "vacation" : route === "/property-requests" ? "requests" : null;
  useEffect(() => {
    const body = document.body, viewport = window.visualViewport;
    let baseline = window.innerHeight, frame;
    body.classList.add("lina-phone-layout");
    const update = () => {
      const field = document.activeElement;
      const editable = field?.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),textarea,[contenteditable="true"]');
      if (!editable) baseline = window.innerHeight;
      const height = viewport?.height || window.innerHeight;
      const keyboard = Boolean(editable && baseline - height > 120 && (viewport?.scale || 1) < 1.1);
      body.classList.toggle("lina-phone-keyboard", keyboard);
      body.style.setProperty("--phone-visible-height", height + "px");
      body.style.setProperty("--phone-visible-top", (viewport?.offsetTop || 0) + "px");
      if (keyboard && field && !field.closest(".lina-ai")) {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const rect = field.getBoundingClientRect();
          if (rect.bottom > height + (viewport?.offsetTop || 0) || rect.top < (viewport?.offsetTop || 0)) field.scrollIntoView({ block: "center" });
        });
      }
    };
    const rotate = () => { baseline = window.innerHeight; update(); };
    update();
    viewport?.addEventListener("resize", update); viewport?.addEventListener("scroll", update);
    window.addEventListener("resize", update); window.addEventListener("orientationchange", rotate);
    document.addEventListener("focusin", update); document.addEventListener("focusout", update);
    return () => {
      cancelAnimationFrame(frame);
      body.classList.remove("lina-phone-layout", "lina-phone-keyboard");
      body.style.removeProperty("--phone-visible-height"); body.style.removeProperty("--phone-visible-top");
      viewport?.removeEventListener("resize", update); viewport?.removeEventListener("scroll", update);
      window.removeEventListener("resize", update); window.removeEventListener("orientationchange", rotate);
      document.removeEventListener("focusin", update); document.removeEventListener("focusout", update);
    };
  }, []);
  return <>
    <div className="phone-top-actions"><HeaderLogo navigate={handleMenuItemClick} /><div><button type="button" aria-label={t("phoneNav.favorites")} onClick={() => handleMenuItemClick("/favorites")}><LuHeart aria-hidden="true" /></button><button type="button" aria-label={t("recent_searches")} onClick={() => handleMenuItemClick("/recent-searches")}><LuBell aria-hidden="true" /></button></div></div>
    <header className={"phone-language" + (route === "/" ? " phone-language-home" : "")}><LanguageSelector variant="row" /></header>
    {context && <h1 className="phone-context">{t("phoneNav." + context)}</h1>}
    <nav className="phone-bottom" aria-label={t("phoneNav.navigation")}>
      <button type="button" aria-current={route === "/" ? "page" : undefined} onClick={() => handleMenuItemClick("/")}><LuHouse aria-hidden="true" /><span>{t("home")}</span></button>
      <button type="button" aria-current={route === "/conversationpage" ? "page" : undefined} onClick={() => handleMenuItemClick("/ConversationPage")}><LuMessagesSquare aria-hidden="true" />{newIncomingMessage && <i className="phone-unread" />}<span>{t("messages")}</span></button>
      <button type="button" className="phone-publish" aria-label={t("add_ad")} onClick={() => { setPanelMode("publish"); setAccountOpen(false); setMenuOpen(true); setAddAdMenuOpen(false); }}><LuPlus aria-hidden="true" /><span>{t("phoneNav.publish")}</span></button>
      <UserMenu open={accountOpen} onOpenChange={open => { setAccountOpen(open); if (open) setMenuOpen(false); }} triggerContent={<><LuUserRound aria-hidden="true" /><span>{t("phoneNav.profile")}</span></>} />
      <button ref={toggleRef} type="button" aria-expanded={menuOpen} aria-controls="lina-mobile-menu" aria-label={t(menuOpen ? "ui.close_menu" : "ui.open_menu")} onClick={openMenu}>{menuOpen ? <LuX aria-hidden="true" /> : <LuMenu aria-hidden="true" />}<span>{t("phoneNav.menu")}</span></button>
    </nav>
    {menuOpen && <HeaderMobileMenu phoneMode={panelMode} {...{toggleMenu, handleMenuItemClick, addAdMenuOpen, setAddAdMenuOpen, handleCreateAdClick, menuRef}} />}
  </>;
}
